import React, { useEffect, useState } from 'react';
import useDragTranslate from '../hooks/useDragTranslate';
import { getRandomWindowPosition } from '../utils/windowPositioning';

const RepositoriesWindow = ({ onClose, zIndex, onFocus }) => {
  const { elRef, onPointerDown, onPointerMove, onPointerUp } = useDragTranslate(onFocus);
  
  // Generate random position for this window
  const [windowPosition] = useState(() => getRandomWindowPosition(600, 500));
  
  const handleFocus = () => {
    onFocus && onFocus();
    /* bring window to front when clicked */
  };

  const handleClose = () => {
    // 1) Add .closing
    elRef.current?.classList.add('closing');

    // 2) After animation end, call onClose to unmount
    const done = () => {
      elRef.current?.removeEventListener('animationend', done);
      onClose();
    };
    elRef.current?.addEventListener('animationend', done, { once: true });
  };

  useEffect(() => {
    // listen on the document so we can move outside the window bounds
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp);
    return () => {
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
    };
  }, [onPointerMove, onPointerUp]);

  return (
    <div
      ref={elRef}
      className="window"
      data-window="repositories"
      style={{
        display: 'block',
        width: '90vh',
        height: '70vh',
        zIndex: zIndex,
        overflow: 'auto',
        position: 'fixed',
        '--tx': `${windowPosition.tx}px`,
        '--ty': `${windowPosition.ty}px`,
        // IMPORTANT: do NOT set left/top/transform here; CSS handles it.
      }}
      onClick={handleFocus}
    >
      <div className="title-bar draggable" onPointerDown={onPointerDown}>
        <div className="title-bar-text">Repositories - Codeviewer.exe</div>
        <div className="title-bar-controls">
          <button aria-label="Close" onClick={handleClose}></button>
        </div>
      </div>
      <div className="window-body">
        <h3>Code Repositories</h3>
        <p>Here's a look at some custom systems I've developed for CFX.RE. These are only repositories I can make public, most of my work is protected. You are also looking at one of my designs as you enjoy this website.<br/><br/><br/></p>

        <b><a href="https://github.com/bobbybuilds/fivemframework" target="_blank" rel="noopener noreferrer">Scalable Framework</a></b>
        <p>This is a small snippet of what I can share of a custom framework I was contracted to make for a FiveM Server. What makes this different from any other framework is the ability this has to scale while achieving ultimate optimization. Each native function called to the player is only called once, and then used as a variable anywhere, while usually in FiveM scripting someone would call GetEntityCoords 500 different times.</p>
        
        <b><a href="https://github.com/bobbybuilds/GTA4-ox_inventory" target="_blank" rel="noopener noreferrer">Inventory System</a></b>
        <p>A more advanced - intuitive fork of ox_inventory redesigned to match the aesthetic of Grand Theft Auto IV.</p>
        
        <b><a href="https://github.com/bobbybuilds/pacificbankheist" target="_blank" rel="noopener noreferrer">Bank Heist</a></b>
        <p>Advanced in-game robbery system using DUI (streamed UI on in-game props) for ultimate immersion and realism. Built upon custom framework as part of a contracted project. These are the snippets I'm able to share of it however major Framework indicators & anti-cheat parameters are left out for security of the client.</p>
        
        <b><a href="https://github.com/bobbybuilds/GTA4-ox_target" target="_blank" rel="noopener noreferrer">Target System</a></b>
        <p>An outdated system for ultimate game optimization - before the days of perfect movement tracking and optimization in the FiveM engine, I created a forked version of ox_target for a client stylized like GTA 4. This system would allow the player to set a keybind which would create a sprite on the screen to check if anything the player is looking at is interactible.</p>
      </div>
    </div>
  );
};

export default RepositoriesWindow;
